import { render } from "./LicenseManagement.vue?vue&type=template&id=46df115b&scoped=true&ts=true"
import script from "./LicenseManagement.vue?vue&type=script&lang=ts"
export * from "./LicenseManagement.vue?vue&type=script&lang=ts"

import "./LicenseManagement.vue?vue&type=style&index=0&id=46df115b&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Administrator\\Documents\\Repos\\PROD-license-management\\redesign\\WebUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46df115b"]])

export default __exports__